import React, { useState } from 'react';
import './RegisterUser.css';
import AuthService from '../Security/AuthService';

const RegisterUser = () => {
  const [formData, setFormData] = useState({
    userId: '',
    password: '',
    role: 'PATIENT',
  });

  const authService = new AuthService();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await authService.register(
        formData.userId,
        formData.password,
        formData.role
      );

      alert(`Account created: ${result.username || "Success"}`);
      sessionStorage.removeItem("userId");
      setFormData({ userId: '', password: '', role: 'PATIENT' });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="register-container">
      <h2>Create Account</h2>
      <form onSubmit={handleSubmit} className="register-form">
        <label>
          User ID:
          <input
            type="text"
            name="userId"
            value={formData.userId}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Password:
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Role:
          <select name="role" value={formData.role} onChange={handleChange}>
            <option value="PATIENT">PATIENT</option>
            <option value="FRONT DESK">FRONT DESK</option>
            <option value="DOCTOR">DOCTOR</option>
            <option value="MANAGER">MANAGER</option>
          </select>
        </label>

        <button type="submit">Register</button>
      </form>
    </div>
  );
};

export default RegisterUser;
